// extracted by mini-css-extract-plugin
export default {"root":"AnnouncementBanner_root__Dbv81","text":"AnnouncementBanner_text__9g6lh"};